import React from 'react'
import GreenIcon from '../../../images/Green Icon.png'

const Step = (props) => {

    const newConnStyle = { minWidth: '8%', width: 'auto' }

    const mcrWithSiteMNTStyle = { minWidth: '7%', width: 'auto', maxWidth: '9.5%' }

    const mrcStyle = { minWidth: '19.75%', width: 'auto', maxWidth: '19.75%' }

    const mcrWithLabMNTStyle = { minWidth: '5%', width: 'auto', maxWidth: '7.6%' }

    const mcrWithOutMNTStyle = { minWidth: '10.9%', width: 'auto' }

    const duedateExtensionStyle = { minWidth: '49%', width: 'auto' }

    const installmentsStyle = { minWidth: '49%', width: 'auto' }

    const defaultStyle = { minWidth: '8%', width: 'auto' }

    const complaintsStyle = { minWidth: '19.75%', width: 'auto' }

    const mcoFormStyle = { width: '25%', minWidth: 0, maxWidth: '25%' }

    const rcoFormStyle = { width: '50%', minWidth: 0, maxWidth: '50%' }

    const tenantCnicFormStyle = { width: '16.666%', minWidth: 0, maxWidth: '16.666%' }

    const albFormStyle = { width: '25%', minWidth: 0, maxWidth: '25%' }

    const coaFormStyle = { flex: '1 1 0', minWidth: 0, width: 'auto', maxWidth: 'none' }

    const ppFormStyle = { width: '33.333%', minWidth: 0, maxWidth: '33.333%' }

    const dcoFormStyle = { width: '33.333%', minWidth: 0, maxWidth: '33.333%' }

    const instFormStyle = { width: '100%', minWidth: 0, maxWidth: '100%' }

    const ddeFormStyle = { width: '100%', minWidth: 0, maxWidth: '100%' }

    const ppReUploadFormStyle = { width: '100%', minWidth: 0, maxWidth: '100%' }

    const reUploadFormStyle = { width: '100%', minWidth: 0, maxWidth: '100%' }

    const ncFormStyle = { flex: '1 1 0', minWidth: 0, width: 'auto', maxWidth: 'none' }

    const stepClass = ['step'];
    if (props.status === 1) stepClass.push('done');
    else if (props.isCurrent) stepClass.push('current');

    return (
        <div className={stepClass.join(' ')}
            style={
                props.pageName === 'MCO Form' ? mcoFormStyle :
                props.pageName === 'RCO Form' ? rcoFormStyle :
                props.pageName === 'Tenant CNIC Form' ? tenantCnicFormStyle :
                props.pageName === 'ALB Form' ? albFormStyle :
                props.pageName === 'COA Form' ? coaFormStyle :
                props.pageName === 'PP Form' ? ppFormStyle :
                props.pageName === 'DCO Form' ? dcoFormStyle :
                props.pageName === 'PP Re-Upload' ? ppReUploadFormStyle :
                props.pageName === 'Re-Upload' ? reUploadFormStyle :
                props.pageName === 'INST Form' ? instFormStyle :
                props.pageName === 'DDE Form' ? ddeFormStyle :
                props.pageName === 'NC Form' ? ncFormStyle :
                props.pageName === 'New Connection' ? newConnStyle :
                    props.pageName === 'Due Date Extension' ? duedateExtensionStyle :
                        props.pageName === 'Installments' ? installmentsStyle :
                            props.pageName === 'Meter Reading Correction' ? mrcStyle :
                                props.pageName === 'Meter Change Request With Site MNT' ? mcrWithSiteMNTStyle :
                                    props.pageName === 'Meter Change Request With Lab MNT' ? mcrWithLabMNTStyle :
                                        props.pageName === 'Meter Change Request Without MNT' ? mcrWithOutMNTStyle :
                                            props.pageName === 'Power Complaints' ? complaintsStyle
                                                : defaultStyle}>
            <div className='span'>
                <div className='span-content'>
                    <div className='icon-button'>
                        {props.status === 0 ? props.number : <img src={GreenIcon} alt="Arear paid bill" width="17" />}
                    </div>
                </div>
                <div className='step-title'>
                    <span style={{ display: 'block' }}>
                        {props.title1}
                    </span>
                    <span style={{ display: 'block' }}>
                        {props.title2}
                    </span>
                </div>
            </div>
        </div >
    )
}

export default Step